export const TRIVIA_FIT_MIN_SCALE = 0.28;

export function nextTriviaFitScale(scale: number): number {
  return Math.max(TRIVIA_FIT_MIN_SCALE, scale - 0.01);
}

/** Choice row min-height in CSS px before fit, matching trivia-stage.css. */
export function triviaChoiceMinHeightPx(choiceCount: number): number {
  return choiceCount > 4 ? 96 : 168;
}

export function triviaQuestionFitsViewport({
  viewportHeight,
  headerPx,
  paddingY,
  choiceCount,
  questionLineEstimate,
  scale,
}: {
  viewportHeight: number;
  headerPx: number;
  paddingY: number;
  choiceCount: number;
  questionLineEstimate: number;
  scale: number;
}): boolean {
  const rows = Math.ceil(choiceCount / 2);
  const gap = (choiceCount > 4 ? 18 : 24) * scale;
  const questionH = 76 * scale * 1.14 * questionLineEstimate;
  const choicesH =
    rows * triviaChoiceMinHeightPx(choiceCount) * scale + (rows - 1) * gap;
  const used = headerPx + paddingY + questionH + gap + choicesH;
  return used <= viewportHeight + 1;
}
